export default "__VITE_ASSET__CGnVwTWM__"